var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 56,
    viewBox: "0 0 76 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_2923)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.203852,
    width: 76,
    height: 56,
    rx: 8,
    fill: "white",
    stroke: "#8392AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5 20.7266C47.5 20.4531 47.3828 20.2188 47.1875 20.0234C46.9922 19.8672 46.7578 19.75 46.5234 19.75H30.9766C30.6641 19.75 30.4297 19.8672 30.2734 20.0234C30.0781 20.2188 30 20.4531 30 20.7266V36.2734C30 36.5469 30.0781 36.7812 30.2734 36.9766C30.4297 37.1719 30.6641 37.25 30.9766 37.25H39.3359V30.4531H37.0703V27.8359H39.3359V25.8828C39.3359 24.7891 39.6484 23.9297 40.2734 23.3047C40.8984 22.7188 41.7188 22.4062 42.7344 22.4062C43.5156 22.4062 44.2188 22.4453 44.7656 22.4844V24.8672H43.3594C42.8516 24.8672 42.5 24.9844 42.3047 25.2188C42.1484 25.4141 42.0703 25.7266 42.0703 26.1562V27.8359H44.6875L44.3359 30.4531H42.0703V37.25H46.5234C46.7969 37.25 47.0312 37.1719 47.2266 36.9766C47.3828 36.7812 47.5 36.5469 47.5 36.2734V20.7266Z",
    fill: "#344E86"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_2923"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 56,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.feadc7a13db87b61035165b9322fca17.svg";
export { ForwardRef as ReactComponent };